<template>
  <div>
    <v-list-item
      v-for="(currentAction, i) in currentActions"
      :key="i"
      @click="changeComponent(currentAction[2])"
    >
      <v-list-item-action>
        <v-icon v-text="currentAction[1]"></v-icon>
      </v-list-item-action>

      <v-list-item-title v-text="currentAction[0]"></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }, 
  computed: {
    currentActions() {
      return [
        [
          this.$t("dashboard.menu.current.create_event"), 
          "fa-plus", 
          "create_event"
        ],
        [
          this.$t("dashboard.menu.current.import_event"),
          "fa-file-import",
          "import_event",
        ], 
        [
          this.$t("dashboard.menu.current.clone_event"), 
          "far fa-copy ", 
          "clone_event"
        ],
      ];
    }
  },
  methods: {
    changeComponent(component, id = null) {
      this.$emit("isComponent", component, id);
      var path;
      let name;
      let params = {};
      if (component == "event_details") {
        path = `/dashBoard/eventDetails/${id}`; 
        name = 'EventDetails'; 
        params = { id };
      }
      else if (component == "race_details") {
        path = `/dashBoard/raceDetails/${id}`;
        name = 'RaceDetails';
        params = { id };
      }
      else if (component == "create_event") {
        path = `/eventList/eventCreate`;
        name = 'EventCreate';
      }
      else if (component == "clone_event") {
        path = `/dashBoard/cloneEvents`;
        name = 'CloneEvents';
      } else if(component == "import_event") {
        path = `/importEvent`;
        name = 'ImportEventOld';
      }
      
      if (path && this.$route.path !== path) {
        this.$router.push({
          //path: path,
          name, params
        });
      }
    },
  },
  //props: { reinit: Number }
};
</script>

<style scoped>
.v-list-item__title {
  text-align: left;
}
.v-list-group__items > div > .v-list-item {
  padding-left: 30px;
}
</style>
